// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const updateUrls = (items, organizationName) => {
  return items.map((item) => {
    const updatedItem = {
      ...item,
      url: item.url ? `/${organizationName}${item.url}` : undefined,
    };

    if (item.children) {
      updatedItem.children = updateUrls(item.children, organizationName);
    }

    return updatedItem;
  });
};

const Navigation = ({organizationName}) => {

  const updateMenuItems = updateUrls(menuItem.items, organizationName)

  const navGroups = updateMenuItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item}/>;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
